import React from 'react';
import { GlobalStyles } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeModeProvider, useThemeMode } from '../../contexts/ThemeModeContext';
import { FaithTheme, FaithThemeDark } from '../../theme';
import AppWithRouterAccess from './AppWithRouterAccess';

/**
 * App Method is executed to load all the components in place
 * and run the application.
 * It also includes the routes declaration.
 */
function RootContent() {
  const { isDarkMode } = useThemeMode();
  const activeTheme = isDarkMode ? FaithThemeDark : FaithTheme;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={activeTheme}>
        <GlobalStyles
          styles={(theme) => ({
            ':root': {
              '--color-bg': theme.palette.background.default,
              '--color-border': theme.palette.border.main,
              '--color-text': theme.palette.text.primary,
              '--color-text-muted': theme.palette.text.muted,
              '--color-primary': theme.palette.primary.main,
              '--color-error': theme.palette.error.main,
              '--color-warning': theme.palette.warning.main,
              '--color-info': theme.palette.info.main,
              '--color-success': theme.palette.success.main,
            },
          })}
        />
        <CssBaseline enableColorScheme />
        <AppWithRouterAccess />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

function Root() {
  return (
    <ThemeModeProvider>
      <RootContent />
    </ThemeModeProvider>
  );
}

export default Root;
